module.exports = __webpack_public_path__ + "static/media/transferencias-white.5ba7e7d9.svg";